import { ALMOXARIFADO_MENU_GROUPS } from "@/constants/almoxarifadoMenu";
import TarefaRecadoDrawer from "@/components/Agenda/TarefaRecadoSidebar/TarefaRecadoDrawer";
import AberturaCaixaModal from "@/components/Financas/FluxoCaixa/AberturaCaixa/AberturaCaixaModal";
import FechamentoCaixaModal from "@/components/Financas/FluxoCaixa/FechamentoCaixa/FechamentoCaixaModal";
import ReforcoModal from "@/components/Financas/FluxoCaixa/Reforco/ReforcoModal";
import SangriaModal from "@/components/Financas/FluxoCaixa/Sangria/SangriaModal";
import TransferenciaModal from "@/components/Financas/FluxoCaixa/Transferencia/TransferenciaModal";
import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Box,
  Button,
  Flex,
  Icon,
  Input,
  Select,
  Text,
  Tooltip,
  useColorModeValue,
  useToast,
  VStack,
  CircularProgress,
  CircularProgressLabel,
} from "@chakra-ui/react";
import { Fragment, useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import {
  FaBoxes,
  FaBriefcase,
  FaBullhorn,
  FaCog,
  FaHandHoldingUsd,
  FaPlug,
  FaTachometerAlt
} from 'react-icons/fa';
import {
  MdAttachMoney,
  MdBusiness,
  MdDateRange,
  MdLocalHospital,
  MdPerson,
} from "react-icons/md";
import {
  useClinic,
} from "../components/Context/ClinicaContext";
import { useUser } from "../components/Context/UserContext";
import {
  useSafeNavigate,
  useTelemedicina,
} from "../context/TelemedicinaContext";
import { usePermissions } from "../hooks/usePermissions";
import { useClinicasComFiliais } from "../modules/ADM/Clinica/hooks/useClinicas";
import { GoSidebarExpand, GoSidebarCollapse } from "react-icons/go";
import { CriarConvenio } from "@/modules/ADM/Convenio";
import { useRequisitosMinimos } from "@/modules/Home/RequisitosMinimos/hooks/useRequisitosMinimos";
import Notificacoes from "./Notificacoes";
import packageInfo from "../../package.json";

const ComingSoonItem = ({ children }) => (
  <Tooltip label="Em breve" placement="right" hasArrow>
    <Text cursor="pointer" opacity={0.45} _hover={{ color: "teal.500" }}>
      {children}
    </Text>
  </Tooltip>
);

const SIDEBAR_COMPACT_QUERY = "(max-width: 1279px)";
const SIDEBAR_DESKTOP_QUERY = "(min-width: 48em)";

const Sidebar = () => {
  const navigate = useSafeNavigate();
  const location = useLocation();
  const toast = useToast();
  const { isWindowOpen: telemedicinaAberta } = useTelemedicina();
  const { selectedClinic, setSelectedClinic } = useClinic();
  const { user, logout } = useUser();
  const { can, canModule } = usePermissions();
  const { data: requisitosData } = useRequisitosMinimos();
  const sidebarBgColor = useColorModeValue("#F7F8FA", "gray.800");
  const textColor = useColorModeValue("teal.800", "teal.200");
  const [isOpen, setIsOpen] = useState(() =>
    typeof window === "undefined" || !window.matchMedia(SIDEBAR_COMPACT_QUERY).matches
  );

  useEffect(() => {
    if (!window.matchMedia(SIDEBAR_DESKTOP_QUERY).matches) {
      setIsOpen(false);
    }
  }, [location.key]);

  useEffect(() => {
    const mediaQuery = window.matchMedia(SIDEBAR_COMPACT_QUERY);
    const handleWidthChange = (event) => {
      if (event.matches) setIsOpen(false);
    };
    mediaQuery.addEventListener("change", handleWidthChange);
    return () => mediaQuery.removeEventListener("change", handleWidthChange);
  }, []);
  const [mostrarConfiguracaoInicial, setMostrarConfiguracaoInicial] = useState(true);
  const requisitosConcluidos = requisitosData?.aprovados?.length || 0;
  const requisitosPendentes = requisitosData?.pendencias?.length || 0;
  const totalRequisitos = requisitosConcluidos + requisitosPendentes;
  const percentualConfiguracao = totalRequisitos > 0
    ? Math.round((requisitosConcluidos / totalRequisitos) * 100)
    : 0;

  const selectedClinicIdRef = useRef(selectedClinic?._id);
  selectedClinicIdRef.current = selectedClinic?._id;

  const { data: clinicas } = useClinicasComFiliais();

  useEffect(() => { if (clinicas) setSelectedClinic(clinicas[0]); }, [clinicas]);

  useEffect(() => {
    if (percentualConfiguracao < 100) {
      setMostrarConfiguracaoInicial(true);
      return undefined;
    }

    const timer = window.setTimeout(() => {
      setMostrarConfiguracaoInicial(false);
    }, 5000);

    return () => window.clearTimeout(timer);
  }, [percentualConfiguracao]);

  const handleClinicChange = (e) => {
    const selectedId = String(e.target.value);
    let foundUnit = null;

    if (clinicas) {
      for (const clinic of clinicas) {
        if (String(clinic._id) === selectedId) {
          foundUnit = clinic;
          break;
        }
        const foundFilial = clinic.filiais?.find(
          (f) => String(f._id) === selectedId,
        );
        if (foundFilial) {
          foundUnit = foundFilial;
          break;
        }
      }
    }

    if (foundUnit) setSelectedClinic(foundUnit);
  };

  return (
    <>
    <Flex
      display={{ base: "flex", md: "none" }}
      align="center"
      justify="space-between"
      px={3}
      py={2}
      bg={sidebarBgColor}
      borderBottomWidth="1px"
      borderColor="gray.200"
      gap={3}
    >
      <Button
        variant="ghost"
        colorScheme="teal"
        minH="44px"
        leftIcon={isOpen ? <GoSidebarExpand size={22} /> : <GoSidebarCollapse size={22} />}
        onClick={() => setIsOpen(v => !v)}
        aria-expanded={isOpen}
        aria-controls="navigation-sidebar"
      >
        {isOpen ? "Fechar menu" : "Menu"}
      </Button>
      {mostrarConfiguracaoInicial && (
        <Button
          variant="ghost"
          size="sm"
          minH="44px"
          onClick={() => window.dispatchEvent(new Event("configuracao-inicial:open"))}
          aria-label={`Configuração inicial: ${percentualConfiguracao}% concluída`}
          gap={2}
        >
          <Text fontSize="xs">Configuração</Text>
          <CircularProgress value={percentualConfiguracao} size="32px" color={percentualConfiguracao === 100 ? "green.400" : "teal.400"} trackColor="gray.100" thickness="10px">
            <CircularProgressLabel fontSize="8px" fontWeight="bold">{percentualConfiguracao}%</CircularProgressLabel>
          </CircularProgress>
        </Button>
      )}
    </Flex>
    <Box
      id="navigation-sidebar"
      display={{ base: isOpen ? "block" : "none", md: "block" }}
      bg={sidebarBgColor}
      color={textColor}
      w={{ base: "100%", md: isOpen ? "250px" : "60px" }}
      maxH={{ base: "60dvh", md: "none" }}
      flexShrink={0}
      py="5"
      borderRight="1px"
      borderColor="gray.200"
      overflow="hidden"
      overflowY={{ base: "auto", md: "hidden" }}
      transition="width 0.2s ease"
    >
      <Box mb="5" px={isOpen ? "5" : "0"}>
        <Flex align="center" justify={isOpen ? "space-between" : "center"} alignItems="flex-start">
          {isOpen && (
            <Text
              fontSize="lg"
              fontWeight="bold"
              color={textColor}
              cursor="pointer"
              onClick={() => navigate("/")}
            >
              OSTEOMEDIC
            </Text>
          )}
          <Notificacoes isOpen={isOpen} />
          <Box cursor="pointer" onClick={() => setIsOpen(v => !v)}>
            {isOpen ? (
              <GoSidebarExpand size={24} />
            ) : (
              <GoSidebarCollapse size={24} />
            )}
          </Box>
        </Flex>
        {isOpen && (user ? (
          <Text fontSize="md" color={textColor}>
            Bem-vindo, {user.nomeCompleto || user.name || "Usuário"}
          </Text>
        ) : (
          <Text fontSize="md" color={textColor}>
            Bem-vindo
          </Text>
        ))}
        {isOpen && (user.role === "Socio" ? (
          <Select
            mt={4}
            value={selectedClinic ? selectedClinic._id : ""}
            onChange={handleClinicChange}
            placeholder="Selecione a clínica"
          >
            {clinicas?.map((clinic) => (
              <Fragment key={clinic._id}>
                <option key={clinic._id} value={clinic._id}>
                  {clinic.nomeFantasia}
                </option>
                {clinic.filiais.map((filial) => (
                  <option key={filial._id} value={filial._id}>
                    ↳ {filial.nomeFantasia}.{filial.ordem}
                  </option>
                ))}
              </Fragment>
            ))}
          </Select>
        ) : (
          <Input type="text" readOnly value={selectedClinic ? selectedClinic.nomeFantasia : ""} mt={3} />
        ))}
        {/* <FormControl display="flex" alignItems="center">
          <FormLabel htmlFor="dark-mode">Modo Noturno</FormLabel>
          <Switch
            id="dark-mode"
            isChecked={colorMode === "dark"}
            onChange={toggleColorMode}
          />
        </FormControl> */}
      </Box>

      <Accordion allowMultiple>
        <VStack align="stretch" spacing="1">
          {mostrarConfiguracaoInicial && (
            <Flex
              direction="column"
              align="center"
              width="90%"
              mx="auto"
              mt={-2}
              gap={2}
            >
              <Flex
                as="button"
                type="button"
                aria-label={`Configuração inicial: ${percentualConfiguracao}% concluída`}
                cursor="pointer"
                onClick={() => window.dispatchEvent(new Event("configuracao-inicial:open"))}
                width="full"
                align="center"
                justify={isOpen ? "space-between" : "center"}
                px={1}
                py={1}
                gap={2}
                minH="50px"
                bg="white"
                border="1px solid"
                borderColor="gray.200"
                borderRadius="lg"
                boxShadow="0 1px 3px rgb(0 0 0 / 8%)"
                _hover={{
                  bg: "gray.50",
                  borderColor: "teal.400",
                }}
              >
                {isOpen && (
                  <Flex align="center">
                    <Text ml={3} fontWeight="medium">
                      Configuração inicial
                    </Text>
                  </Flex>
                )}
                <CircularProgress
                  value={percentualConfiguracao}
                  color={percentualConfiguracao === 100 ? "green.400" : "teal.400"}
                  trackColor="gray.100"
                  size="32px"
                  thickness="10px"
                  flexShrink={0}
                >
                  <CircularProgressLabel fontSize="8px" fontWeight="bold">
                    {percentualConfiguracao}%
                  </CircularProgressLabel>
                </CircularProgress>
              </Flex>
            </Flex>
          )}

          {canModule('agenda') && (
            <AccordionItem>
              <AccordionButton
                _hover={{ bg: "teal.500", color: "white" }}
                justifyContent={!isOpen ? "center" : undefined}
                onClick={!isOpen ? () => setIsOpen(true) : undefined}
              >
                <Flex align="center" flex={isOpen ? "1" : undefined} textAlign="left">
                  <Icon as={MdDateRange} fontSize="20px" />
                  {isOpen && <Text ml="3" fontWeight="medium">Agenda</Text>}
                </Flex>
                {isOpen && <AccordionIcon />}
              </AccordionButton>
              <AccordionPanel pb={4} display={isOpen ? undefined : "none"}>
                <VStack align="stretch" pl={10}>
                  {can('agenda', 'agenda') && (
                    <Text
                      cursor="pointer"
                      _hover={{ color: "teal.500" }}
                      onClick={() => navigate("/agenda")}
                    >
                      Agenda
                    </Text>
                  )}
                  {can('agenda', 'mapaDeSala') && (
                    <Text
                      cursor="pointer"
                      _hover={{ color: "teal.500" }}
                      onClick={() => navigate("/adm/salas")}
                    >
                      Mapa de Sala
                    </Text>
                  )}
                  {can('agenda', 'notificacoes') && (
                    <Text
                      cursor="pointer"
                      _hover={{ color: "teal.500" }}
                      onClick={() => navigate("/notificacoes")}
                    >
                      Notificações
                    </Text>
                  )}
                </VStack>
              </AccordionPanel>
            </AccordionItem>
          )}

          {canModule('pacientes') && (
            <AccordionItem>
              <AccordionButton
                _hover={{ bg: "teal.500", color: "white" }}
                justifyContent={!isOpen ? "center" : undefined}
                onClick={!isOpen ? () => setIsOpen(true) : undefined}
              >
                <Flex align="center" flex={isOpen ? "1" : undefined} textAlign="left">
                  <Icon as={MdPerson} fontSize="20px" />
                  {isOpen && <Text ml="3" fontWeight="medium">Pacientes</Text>}
                </Flex>
                {isOpen && <AccordionIcon />}
              </AccordionButton>
              <AccordionPanel pb={4} display={isOpen ? undefined : "none"}>
                <VStack align="stretch" pl={10}>
                  {can('pacientes', 'listaPacientes') && (
                    <Text
                      cursor="pointer"
                      _hover={{ color: "teal.500" }}
                      onClick={() => navigate("/pacientes")}
                    >
                      Lista de Pacientes
                    </Text>
                  )}
                  {can('pacientes', 'listaEspera') && (
                    <Text
                      cursor="pointer"
                      _hover={{ color: "teal.500" }}
                      onClick={() => navigate("/lista-espera")}
                    >
                      Lista de Espera
                    </Text>
                  )}
                  {can('pacientes', 'relatorioConsultas') && (
                    <ComingSoonItem>Relatório de Consultas</ComingSoonItem>
                  )}
                  {/* <Text
                  cursor="pointer"
                  _hover={{ color: "teal.500" }}
                  onClick={() => navigate("/historico-exclusoes")}
                >
                  Histórico de Logs
                </Text> */}
                </VStack>
              </AccordionPanel>
            </AccordionItem>
          )}

          {canModule('administrativo') && (
            <AccordionItem>
              <AccordionButton
                _hover={{ bg: "teal.500", color: "white" }}
                justifyContent={!isOpen ? "center" : undefined}
                onClick={!isOpen ? () => setIsOpen(true) : undefined}
              >
                <Flex align="center" flex={isOpen ? "1" : undefined} textAlign="left">
                  <Icon as={MdBusiness} fontSize="20px" />
                  {isOpen && <Text ml="3" fontWeight="medium">Administrativo</Text>}
                </Flex>
                {isOpen && <AccordionIcon />}
              </AccordionButton>
              <AccordionPanel pb={4} display={isOpen ? undefined : "none"}>
                <VStack align="stretch" pl={10}>
                  {can('administrativo', 'clinicas') && (
                    <Text
                      cursor="pointer"
                      _hover={{ color: "teal.500" }}
                      onClick={() => navigate("/adm/clinica")}
                    >
                      Clínicas
                    </Text>
                  )}
                  {can('administrativo', 'especialidades') && (
                    <Text
                      cursor="pointer"
                      _hover={{ color: "teal.500" }}
                      onClick={() => navigate("/adm/especialidades")}
                    >
                      Especialidades
                    </Text>
                  )}
                  {can('administrativo', 'pacotes') && (
                    <Text
                      cursor="pointer"
                      _hover={{ color: "teal.500" }}
                      onClick={() => navigate("/adm/pacotesplanos")}
                    >
                      Pacotes e Planos
                    </Text>
                  )}
                  {can('administrativo', 'procedimentos') && (
                    <Text
                      cursor="pointer"
                      _hover={{ color: "teal.500" }}
                      onClick={() => navigate("/adm/procedimentos")}
                    >
                      Procedimentos
                    </Text>
                  )}
                  {can('administrativo', 'tabelaProcedimentos') && (
                    <Text
                      cursor="pointer"
                      _hover={{ color: "teal.500" }}
                      onClick={() => navigate("/adm/tabelaprocedimentos")}
                    >
                      Tabela Procedimentos
                    </Text>
                  )}
                  {can('administrativo', 'colaboradores') && (
                    <Text
                      cursor="pointer"
                      _hover={{ color: "teal.500" }}
                      onClick={() => navigate("/adm/colaboradores")}
                    >
                      Colaboradores
                    </Text>
                  )}
                  {can('administrativo', 'profissionaisSaude') && (
                    <Text
                      cursor="pointer"
                      _hover={{ color: "teal.500" }}
                      onClick={() => navigate("/adm/prossaudes")}
                    >
                      Profissionais de Saúde
                    </Text>
                  )}
                  {can('administrativo', 'turnoTrabalho') && (
                    <Text
                      cursor="pointer"
                      _hover={{ color: "teal.500" }}
                      onClick={() => navigate("/adm/turnotrabalho")}
                    >
                      Turno de Trabalho
                    </Text>
                  )}
                  {can('administrativo', 'repasses') && (
                    <Text
                      cursor="pointer"
                      _hover={{ color: "teal.500" }}
                      onClick={() => navigate("/adm/repassescomissoes")}
                    >
                      Repasses
                    </Text>
                  )}
                  {can('administrativo', 'contratos') && (
                    <ComingSoonItem>Contratos</ComingSoonItem>
                  )}
                  {can('administrativo', 'gerenciamentoPlanos') && (
                    <Text
                      cursor="pointer"
                      _hover={{ color: "teal.500" }}
                      onClick={() => navigate("/financas/gestao-planos")}
                    >
                      Gerenciamento de planos
                    </Text>
                  )}
                  {can('administrativo', 'relatorios') && (
                    <>
                      <Text
                        cursor="pointer"
                        _hover={{ color: "teal.500" }}
                        onClick={() => navigate("/adm/relatorios-profissional")}
                      >
                        Relatório de profissionais
                      </Text>
                      <Text
                        cursor="pointer"
                        _hover={{ color: "teal.500" }}
                        onClick={() => navigate("/adm/relatorio-isencoes")}
                      >
                        Isenções e repasses negociados
                      </Text>
                    </>
                  )}
                  {can('administrativo', 'assinaturaEletronica') && (
                    <ComingSoonItem>Assinatura Eletrônica</ComingSoonItem>
                  )}
                  {can('administrativo', 'chatInterno') && (
                    <Text
                      cursor="pointer"
                      _hover={{ color: "teal.500" }}
                      onClick={() => window.dispatchEvent(new Event('chat:open'))}
                    >
                      Chat Interno
                    </Text>
                  )}
                  {can('administrativo', 'tarefaRecado') && (
                    <TarefaRecadoDrawer clinicaId={selectedClinic?._id}>
                      {({ onOpen }) => (
                        <Text
                          cursor="pointer"
                          _hover={{ color: "teal.500" }}
                          onClick={onOpen}
                        >
                          Tarefa / Recado
                        </Text>
                      )}
                    </TarefaRecadoDrawer>
                  )}
                </VStack>
              </AccordionPanel>
            </AccordionItem>
          )}

          {canModule('prontuarios') && (
            <AccordionItem>
              <AccordionButton
                _hover={{ bg: "teal.500", color: "white" }}
                justifyContent={!isOpen ? "center" : undefined}
                onClick={!isOpen ? () => setIsOpen(true) : undefined}
              >
                <Flex align="center" flex={isOpen ? "1" : undefined} textAlign="left">
                  <Icon as={MdLocalHospital} fontSize="20px" />
                  {isOpen && <Text ml="3" fontWeight="medium">Prontuários</Text>}
                </Flex>
                {isOpen && <AccordionIcon />}
              </AccordionButton>
              <AccordionPanel pb={4} display={isOpen ? undefined : "none"}>
                <VStack align="stretch" pl={10}>
                  {can('prontuarios', 'anamnese') && (
                    <Text
                      cursor="pointer"
                      _hover={{ color: "teal.500" }}
                      onClick={() => navigate("/prosaude/anamnese")}
                    >
                      Anamnese Padrão
                    </Text>
                  )}
                  {can('prontuarios', 'anamnese') && (
                    <Text
                      cursor="pointer"
                      _hover={{ color: "teal.500" }}
                      onClick={() => navigate("/prosaude/anamnese")}
                    >
                      Anamnese Personalizada
                    </Text>
                  )}
                  {can('prontuarios', 'atestados') && (
                    <Text
                      cursor="pointer"
                      _hover={{ color: "teal.500" }}
                      onClick={() => navigate("/prosaude/documentos/atestados")}
                    >
                      Atestado
                    </Text>
                  )}
                  {can('prontuarios', 'encaminhamentos') && (
                    <Text
                      cursor="pointer"
                      _hover={{ color: "teal.500" }}
                      onClick={() =>
                        navigate("/prosaude/documentos/encaminhamentos")
                      }
                    >
                      Encaminhamentos
                    </Text>
                  )}
                  {can('prontuarios', 'solicitacaoProcedimentos') && (
                    <Text
                      cursor="pointer"
                      _hover={{ color: "teal.500" }}
                      onClick={() =>
                        navigate("/prosaude/documentos/solicitacao-procedimentos")
                      }
                    >
                      Solicitação de Procedimentos
                    </Text>
                  )}
                  {can('prontuarios', 'prescricoes') && (
                    <Text
                      cursor="pointer"
                      _hover={{ color: "teal.500" }}
                      onClick={() => navigate("/prosaude/documentos/prescricoes")}
                    >
                      Prescrições
                    </Text>
                  )}
                  {can('prontuarios', 'comprovacaoHoras') && (
                    <Text
                      cursor="pointer"
                      _hover={{ color: "teal.500" }}
                      onClick={() =>
                        navigate("/prosaude/documentos/comprovacao-horas")
                      }
                    >
                      Comprovação de Horas
                    </Text>
                  )}
                  {can('prontuarios', 'orcamentos') && (
                    <Text
                      cursor="pointer"
                      _hover={{ color: "teal.500" }}
                      onClick={() => navigate("/prosaude/documentos/orcamentos")}
                    >
                      Orçamento
                    </Text>
                  )}
                  {can('prontuarios', 'documentoPadrao') && (
                    <Text
                      cursor="pointer"
                      _hover={{ color: "teal.500" }}
                      onClick={() => navigate("/prosaude/modelodocumento")}
                    >
                      Documento Padrão
                    </Text>
                  )}
                </VStack>
              </AccordionPanel>
            </AccordionItem>
          )}

          {canModule('convenios') && (
            <AccordionItem>
              <AccordionButton
                _hover={{ bg: "teal.500", color: "white" }}
                justifyContent={!isOpen ? "center" : undefined}
                onClick={!isOpen ? () => setIsOpen(true) : undefined}
              >
                <Flex align="center" flex={isOpen ? "1" : undefined} textAlign="left">
                  <Icon as={FaHandHoldingUsd} fontSize="20px" />
                  {isOpen && <Text ml="3" fontWeight="medium">Convênios</Text>}
                </Flex>
                {isOpen && <AccordionIcon />}
              </AccordionButton>
              <AccordionPanel pb={4} display={isOpen ? undefined : "none"}>
                <VStack align="stretch" pl={10}>
                  {can('convenios', 'cadastro') && (
                    <Text
                      cursor="pointer"
                      _hover={{ color: "teal.500" }}
                      onClick={() => navigate("/adm/convenios")}
                    >
                      Convênio
                    </Text>
                  )}
                  {can('convenios', 'cadastro') && (
                    <CriarConvenio>
                      {({ onOpen }) => (
                        <Text
                          cursor="pointer"
                          _hover={{ color: "teal.500" }}
                          onClick={onOpen}
                        >
                          Cadastro de Convênio
                        </Text>
                      )}
                    </CriarConvenio>
                  )}
                  {can('convenios', 'tabelaProcedimentos') && (
                    <Text
                      cursor="pointer"
                      _hover={{ color: "teal.500" }}
                      onClick={() => navigate("/convenio/tabelaprocedimentos")}
                    >
                      Tabela de Procedimentos de Convênio
                    </Text>
                  )}
                  {can('convenios', 'guiasConsulta') && (
                    <ComingSoonItem>Guias de Consulta SP/SADT</ComingSoonItem>
                  )}
                  {can('convenios', 'lote') && (
                    <ComingSoonItem>Lote</ComingSoonItem>
                  )}
                  {can('convenios', 'repasse') && (
                    <ComingSoonItem>Repasse</ComingSoonItem>
                  )}
                  {can('convenios', 'gestaoGlosa') && (
                    <ComingSoonItem>Gestão de Glosa</ComingSoonItem>
                  )}
                </VStack>
              </AccordionPanel>
            </AccordionItem>
          )}

          {canModule('financas') && (
            <AccordionItem>
              <AccordionButton
                _hover={{ bg: "teal.500", color: "white" }}
                justifyContent={!isOpen ? "center" : undefined}
                onClick={!isOpen ? () => setIsOpen(true) : undefined}
              >
                <Flex align="center" flex={isOpen ? "1" : undefined} textAlign="left">
                  <Icon as={MdAttachMoney} fontSize="20px" />
                  {isOpen && <Text ml="3" fontWeight="medium">Finanças</Text>}
                </Flex>
                {isOpen && <AccordionIcon />}
              </AccordionButton>
              <AccordionPanel pb={4} display={isOpen ? undefined : "none"}>
                <VStack align="stretch" pl={10}>
                  {can('financas', 'contasBancarias') && (
                    <Text
                      cursor="pointer"
                      _hover={{ color: "teal.500" }}
                      onClick={() => navigate("/financas/contasbancarias")}
                    >
                      Contas Bancárias
                    </Text>
                  )}
                  {can('financas', 'centroCusto') && (
                    <Text
                      cursor="pointer"
                      _hover={{ color: "teal.500" }}
                      onClick={() => navigate("/financas/centrocusto")}
                    >
                      Centro de Custo
                    </Text>
                  )}
                  {can('financas', 'fornecedores') && (
                    <Text
                      cursor="pointer"
                      _hover={{ color: "teal.500" }}
                      onClick={() => navigate("/financas/fornecedores")}
                    >
                      Fornecedores
                    </Text>
                  )}
                  {can('financas', 'formaPagamento') && (
                    <Text
                      cursor="pointer"
                      _hover={{ color: "teal.500" }}
                      onClick={() => navigate("/financas/formapagamento")}
                    >
                      Forma de Pagamento
                    </Text>
                  )}
                  {can('financas', 'contasPagar') && (
                    <Text
                      cursor="pointer"
                      _hover={{ color: "teal.500" }}
                      onClick={() => navigate("/financas/contaspagar")}
                    >
                      Contas a Pagar
                    </Text>
                  )}
                  {can('financas', 'contasReceber') && (
                    <Text
                      cursor="pointer"
                      _hover={{ color: "teal.500" }}
                      onClick={() => navigate("/financas/contasreceber")}
                    >
                      Contas a Receber
                    </Text>
                  )}
                  {can('financas', 'conciliacao') && (
                    <Text
                      cursor="pointer"
                      _hover={{ color: "teal.500" }}
                      onClick={() => navigate("/financas/conciliacao")}
                    >
                      Conciliação bancária
                    </Text>
                  )}
                  {can('financas', 'fluxoCaixa') && (
                    <Text
                      cursor="pointer"
                      _hover={{ color: "teal.500" }}
                      onClick={() => navigate("/financas/fluxocaixa")}
                    >
                      Fluxo de Caixa
                    </Text>
                  )}
                  {can('financas', 'dre') && (
                    <Text
                      cursor="pointer"
                      _hover={{ color: "teal.500" }}
                      onClick={() => navigate("/financas/dre")}
                    >
                      DRE
                    </Text>
                  )}
                  {can('financas', 'descontos') && (
                    <Text
                      cursor="pointer"
                      _hover={{ color: "teal.500" }}
                      onClick={() => navigate("/financas/descontos")}
                    >
                     Relatório de descontos
                    </Text>
                  )}
                  {['aberturaCaixa', 'reforco', 'sangria', 'transferencia', 'fechamentoCaixa'].some((permission) => can('financas', permission)) && (
                    <Accordion allowToggle width="100%">
                      <AccordionItem border="none">
                        <AccordionButton px={0} py={1.5} _hover={{ bg: "teal.500", color: "white" }}>
                          <Text flex="1" textAlign="left" fontWeight="medium">
                            Tesouraria
                          </Text>
                          <AccordionIcon />
                        </AccordionButton>
                        <AccordionPanel p={0}>
                          <VStack align="stretch" spacing={1}>
                            {[
                              { permission: 'aberturaCaixa', label: 'Abertura de caixa', Modal: AberturaCaixaModal },
                              { permission: 'reforco', label: 'Reforço', Modal: ReforcoModal },
                              { permission: 'sangria', label: 'Sangria', Modal: SangriaModal },
                              { permission: 'transferencia', label: 'Transferência entre contas bancárias', Modal: TransferenciaModal },
                              { permission: 'fechamentoCaixa', label: 'Fechamento de caixa', Modal: FechamentoCaixaModal },
                            ].filter((item) => can('financas', item.permission)).map(({ permission, label, Modal }) => (
                              <Modal key={permission}>
                                {({ onOpen }) => (
                                  <Button
                                    variant="ghost"
                                    size="sm"
                                    justifyContent="flex-start"
                                    whiteSpace="normal"
                                    textAlign="left"
                                    height="auto"
                                    minH={8}
                                    py={1.5}
                                    px={2}
                                    fontFamily="inherit"
                                    fontSize="inherit"
                                    fontWeight="normal"
                                    lineHeight="inherit"
                                    color="inherit"
                                    _hover={{ bg: "transparent", color: "teal.500" }}
                                    _active={{ bg: "transparent" }}
                                    onClick={onOpen}
                                  >
                                    {label}
                                  </Button>
                                )}
                              </Modal>
                            ))}
                          </VStack>
                        </AccordionPanel>
                      </AccordionItem>
                    </Accordion>
                  )}
                  {can('financas', 'fiscal') && (
                    <Accordion allowToggle width="100%">
                      <AccordionItem border="none" isDisabled>
                        <AccordionButton px={0} py={1.5} _hover={{ bg: "teal.500", color: "white" }}>
                          <Text flex="1" textAlign="left" fontWeight="medium">
                            Fiscal
                          </Text>
                          <AccordionIcon />
                        </AccordionButton>
                        <AccordionPanel p={0}>
                          <VStack align="stretch" spacing={1}>
                            {[
                              { label: 'Dados Fiscais da Unidade', path: '/financas/dados-fiscais' },
                              { label: 'Apuração Fiscal de Estoque', path: '/financas/apuracao-fiscal-estoque' },
                              { label: 'Regras Fiscais', path: '/financas/regras-fiscais' },
                              { label: 'Perfil Fiscal de Produto', path: '/financas/perfil-fiscal-produto' },
                              { label: 'Catálogo Fiscal', path: '/financas/catalogo-fiscal' },
                              { label: 'Pendências Fiscais', path: '/financas/pendencias-fiscais' },
                            ].map((item) => (
                              <Button
                                key={item.path}
                                variant="ghost"
                                size="sm"
                                justifyContent="flex-start"
                                whiteSpace="normal"
                                textAlign="left"
                                height="auto"
                                minH={8}
                                py={1.5}
                                px={2}
                                fontFamily="inherit"
                                fontSize="inherit"
                                fontWeight="normal"
                                lineHeight="inherit"
                                color="inherit"
                                _hover={{ bg: "transparent", color: "teal.500" }}
                                _active={{ bg: "transparent" }}
                                onClick={() => navigate(item.path)}
                              >
                                {item.label}
                              </Button>
                            ))}
                          </VStack>
                        </AccordionPanel>
                      </AccordionItem>
                    </Accordion>
                  )}
                </VStack>
              </AccordionPanel>
            </AccordionItem>
          )}

          {canModule('almoxarifado') && (
            <AccordionItem isDisabled>
              <AccordionButton
                _hover={{ bg: "teal.500", color: "white" }}
                justifyContent={!isOpen ? "center" : undefined}
                //onClick={!isOpen ? () => setIsOpen(true) : undefined}
              >
                <Flex align="center" flex={isOpen ? "1" : undefined} textAlign="left">
                  <Icon as={FaBoxes} fontSize="20px" />
                  {isOpen && <Text ml="3" fontWeight="medium">Almoxarifado</Text>}
                </Flex>
                {isOpen && <AccordionIcon />}
              </AccordionButton>
              <AccordionPanel pb={4} display={isOpen ? undefined : "none"}>
                <VStack align="stretch" pl={6} spacing={3}>
                  {ALMOXARIFADO_MENU_GROUPS.map((group) => {
                    const items = group.items.filter((item) => can('almoxarifado', item.permission));
                    if (!items.length) return null;

                    return (
                      <Accordion key={group.label} allowToggle>
                        <AccordionItem border="none">
                          <AccordionButton px={2} py={1.5} _hover={{ bg: "teal.500", color: "white" }}>
                            <Text flex="1" textAlign="left" fontWeight="medium">
                              {group.label}
                            </Text>
                            <AccordionIcon />
                          </AccordionButton>
                          <AccordionPanel p={0}>
                            <VStack align="stretch" spacing={1}>
                              {items.map((item) => (
                                <Button
                                  key={item.path}
                                  variant="ghost"
                                  size="sm"
                                  justifyContent="flex-start"
                                  whiteSpace="normal"
                                  textAlign="left"
                                  height="auto"
                                  minH={8}
                                  py={1.5}
                                  px={2}
                                  fontFamily="inherit"
                                  fontSize="inherit"
                                  fontWeight="normal"
                                  lineHeight="inherit"
                                  color="inherit"
                                  _hover={{ bg: "transparent", color: "teal.500" }}
                                  _active={{ bg: "transparent" }}
                                  onClick={() => navigate(item.path)}
                                >
                                  {item.label}
                                </Button>
                              ))}
                            </VStack>
                          </AccordionPanel>
                        </AccordionItem>
                      </Accordion>
                    );
                  })}
                </VStack>
              </AccordionPanel>
            </AccordionItem>
          )}

          {canModule('crm') && (
            <AccordionItem>
              <AccordionButton
                _hover={{ bg: "teal.500", color: "white" }}
                justifyContent={!isOpen ? "center" : undefined}
                onClick={!isOpen ? () => setIsOpen(true) : undefined}
              >
                <Flex align="center" flex={isOpen ? "1" : undefined} textAlign="left">
                  <Icon as={FaBullhorn} fontSize="20px" />
                  {isOpen && <Text ml="3" fontWeight="medium">CRM - Marketing</Text>}
                </Flex>
                {isOpen && <AccordionIcon />}
              </AccordionButton>
              <AccordionPanel pb={4} display={isOpen ? undefined : "none"}>
                <VStack align="stretch" pl={10}>
                  {can('crm', 'automacaoWhatsapp') && (
                    <ComingSoonItem>Automação do WhatApp</ComingSoonItem>
                  )}
                  {can('crm', 'emailMarketing') && (
                    <ComingSoonItem>E-mail Marketing</ComingSoonItem>
                  )}
                  {can('crm', 'automacaoPredefinida') && (
                    <ComingSoonItem>Automação Pre-definida</ComingSoonItem>
                  )}
                  {can('crm', 'automacaoPersonalizada') && (
                    <ComingSoonItem>Automação Personalizada</ComingSoonItem>
                  )}
                  {can('crm', 'nps') && (
                    <Text
                      cursor="pointer"
                      _hover={{ color: "teal.500" }}
                      onClick={() => navigate("/marketing/nps")}
                    >
                      NPS
                    </Text>
                  )}
                  {can('crm', 'leads') && (
                    <Text
                      cursor="pointer"
                      _hover={{ color: "teal.500" }}
                      onClick={() => navigate("/marketing/leads")}
                    >
                      Leads
                    </Text>
                  )}
                  {can('crm', 'funilVendas') && (
                    <Text
                      cursor="pointer"
                      _hover={{ color: "teal.500" }}
                      onClick={() => navigate("/marketing/funil-vendas")}
                    >
                      Funil de Vendas
                    </Text>
                  )}
                  {can('crm', 'clubeFidelidade') && (
                    <ComingSoonItem>Club de Fidelidade</ComingSoonItem>
                  )}
                </VStack>
              </AccordionPanel>
            </AccordionItem>
          )}

          {canModule('gestaoNegocio') && (
            <AccordionItem>
              <AccordionButton
                _hover={{ bg: "teal.500", color: "white" }}
                justifyContent={!isOpen ? "center" : undefined}
                onClick={!isOpen ? () => setIsOpen(true) : undefined}
              >
                <Flex align="center" flex={isOpen ? "1" : undefined} textAlign="left">
                  <Icon as={FaBriefcase} fontSize="20px" />
                  {isOpen && <Text ml="3" fontWeight="medium">Gestão do Negócio</Text>}
                </Flex>
                {isOpen && <AccordionIcon />}
              </AccordionButton>
              <AccordionPanel pb={4} display={isOpen ? undefined : "none"}>
                <VStack align="stretch" pl={10}>
                  {can('gestaoNegocio', 'canvaModelo') && (
                    <ComingSoonItem>Canva Modelo de Negócio</ComingSoonItem>
                  )}
                  {can('gestaoNegocio', 'proposito') && (
                    <ComingSoonItem>Propósito, missão, visão e valores</ComingSoonItem>
                  )}
                  {can('gestaoNegocio', 'analiseSwot') && (
                    <ComingSoonItem>Análise SWORT</ComingSoonItem>
                  )}
                  {can('gestaoNegocio', 'metasSmart') && (
                    <ComingSoonItem>metas SMART</ComingSoonItem>
                  )}
                  {can('gestaoNegocio', 'cincoW2H') && (
                    <ComingSoonItem>5W 2H</ComingSoonItem>
                  )}
                  {can('gestaoNegocio', 'planejamentoMetas') && (
                    <ComingSoonItem>Planejamento das Metas Financeiras</ComingSoonItem>
                  )}
                  {can('gestaoNegocio', 'precificacao') && (
                    <ComingSoonItem>Precificação</ComingSoonItem>
                  )}
                  {can('gestaoNegocio', 'pontoEquilibrio') && (
                    <ComingSoonItem>Ponto de Equilíbrio</ComingSoonItem>
                  )}
                  {can('gestaoNegocio', 'pdca') && (
                    <ComingSoonItem>PDCA</ComingSoonItem>
                  )}
                  {can('gestaoNegocio', 'descritivoFuncao') && (
                    <ComingSoonItem>Descritivo de Função</ComingSoonItem>
                  )}
                  {can('gestaoNegocio', 'disc') && (
                    <ComingSoonItem>DISC</ComingSoonItem>
                  )}
                  {can('gestaoNegocio', 'tributacao') && (
                    <ComingSoonItem>Tributação</ComingSoonItem>
                  )}
                </VStack>
              </AccordionPanel>
            </AccordionItem>
          )}

          {canModule('dashboard') && (
            <AccordionItem>
              <AccordionButton
                _hover={{ bg: "teal.500", color: "white" }}
                justifyContent={!isOpen ? "center" : undefined}
                onClick={!isOpen ? () => setIsOpen(true) : undefined}
              >
                <Flex align="center" flex={isOpen ? "1" : undefined} textAlign="left">
                  <Icon as={FaTachometerAlt} fontSize="20px" />
                  {isOpen && <Text ml="3" fontWeight="medium">Dashboard - KPIS</Text>}
                </Flex>
                {isOpen && <AccordionIcon />}
              </AccordionButton>
              <AccordionPanel pb={4} display={isOpen ? undefined : "none"}>
                <VStack align="stretch" pl={10}>
                  {can('dashboard', 'agenda') && (
                    <ComingSoonItem>Agenda</ComingSoonItem>
                  )}
                  {can('dashboard', 'pacientes') && (
                    <ComingSoonItem>Pacientes</ComingSoonItem>
                  )}
                  {can('dashboard', 'administrativo') && (
                    <Text
                      cursor="pointer"
                      _hover={{ color: "teal.500" }}
                      onClick={() => navigate("/adm/dashboard")}
                    >
                      Administrativo
                    </Text>
                  )}
                  {can('dashboard', 'convenios') && (
                    <ComingSoonItem>Convênios</ComingSoonItem>
                  )}
                  {can('dashboard', 'financeiro') && (
                    <Text
                      cursor="pointer"
                      _hover={{ color: "teal.500" }}
                      onClick={() => navigate("/financas/dashboard")}
                    >
                      Financeiro
                    </Text>
                  )}
                  {can('dashboard', 'almoxarifado') && (
                    <ComingSoonItem>Almoxarifado</ComingSoonItem>
                  )}
                  {can('dashboard', 'marketing') && (
                    <Text
                      cursor="pointer"
                      _hover={{ color: "teal.500" }}
                      onClick={() => navigate("/marketing/dashboard")}
                    >
                      Marketing
                    </Text>
                  )}
                  {can('dashboard', 'gestaoNegocio') && (
                    <ComingSoonItem>Gestão do Negócio</ComingSoonItem>
                  )}
                </VStack>
              </AccordionPanel>
            </AccordionItem>
          )}

          {canModule('integracoes') && (
            <AccordionItem>
              <AccordionButton
                _hover={{ bg: "teal.500", color: "white" }}
                justifyContent={!isOpen ? "center" : undefined}
                onClick={!isOpen ? () => setIsOpen(true) : undefined}
              >
                <Flex align="center" flex={isOpen ? "1" : undefined} textAlign="left">
                  <Icon as={FaPlug} fontSize="20px" />
                  {isOpen && <Text ml="3" fontWeight="medium">Integrações</Text>}
                </Flex>
                {isOpen && <AccordionIcon />}
              </AccordionButton>
              <AccordionPanel pb={4} display={isOpen ? undefined : "none"}>
                <VStack align="stretch" pl={10}>
                  {can('integracoes', 'doctoralia') && (
                    <ComingSoonItem>Doctoralia</ComingSoonItem>
                  )}
                  {can('integracoes', 'totalPass') && (
                    <ComingSoonItem>TotalPass</ComingSoonItem>
                  )}
                  {can('integracoes', 'wellhub') && (
                    <ComingSoonItem>Wellhub</ComingSoonItem>
                  )}
                  {can('integracoes', 'doc4sign') && (
                    <ComingSoonItem>Doc4sign</ComingSoonItem>
                  )}
                  {can('integracoes', 'googleCalendar') && (
                    <Text
                      cursor="pointer"
                      _hover={{ color: "teal.500" }}
                      onClick={() => navigate("/configuracoes/google-calendar")}
                    >
                      Google Calendar
                    </Text>
                  )}
                  {can('integracoes', 'memed') && (
                    <ComingSoonItem>Memed</ComingSoonItem>
                  )}
                  {can('integracoes', 'nfEletronica') && (
                    <ComingSoonItem>NF Eletrônica</ComingSoonItem>
                  )}
                  {can('integracoes', 'apiWhatsapp') && (
                    <ComingSoonItem>API oficial WhatsApp</ComingSoonItem>
                  )}
                  {can('integracoes', 'personalizacao') && (
                    <ComingSoonItem>Personalização - consulte nossa equipe</ComingSoonItem>
                  )}
                </VStack>
              </AccordionPanel>
            </AccordionItem>
          )}

          {canModule('configuracoes') && (
            <AccordionItem>
              <AccordionButton
                _hover={{ bg: "teal.500", color: "white" }}
                justifyContent={!isOpen ? "center" : undefined}
                onClick={!isOpen ? () => setIsOpen(true) : undefined}
              >
                <Flex align="center" flex={isOpen ? "1" : undefined} textAlign="left">
                  <Icon as={FaCog} fontSize="20px" />
                  {isOpen && <Text ml="3" fontWeight="medium">Configurações</Text>}
                </Flex>
                {isOpen && <AccordionIcon />}
              </AccordionButton>
              <AccordionPanel pb={4} display={isOpen ? undefined : "none"}>
                <VStack align="stretch" pl={10}>
                  {can('configuracoes', 'controleUsuario') && (
                    <Text
                      cursor="pointer"
                      _hover={{ color: "teal.500" }}
                      onClick={() => navigate("/adm/controleusuarios")}
                    >
                      Controle de Usuário
                    </Text>
                  )}
                  {can('configuracoes', 'vinculadas') && (
                    <Text
                      cursor="pointer"
                      _hover={{ color: "teal.500" }}
                      onClick={() => navigate("/configuracoes/whatsapp")}
                    >
                      WhatsApp
                    </Text>
                  )}
                  {can('configuracoes', 'historicoLogs') && (
                    <Text
                      cursor="pointer"
                      _hover={{ color: "teal.500" }}
                      onClick={() => navigate("/historico-exclusoes")}
                    >
                      Histórico de Logs
                    </Text>
                  )}
                  {can('configuracoes', 'exportarInformacoes') && (
                    <ComingSoonItem>Exportar informações do sistema</ComingSoonItem>
                  )}
                  {can('configuracoes', 'agendamentoOnline') && (
                    <Text
                      cursor="pointer"
                      _hover={{ color: "teal.500" }}
                      onClick={() => navigate("/configuracoes/agendamentoOnline")}
                    >
                      Agendamento Online
                    </Text>
                  )}
                  {can('configuracoes', 'parametro') && (
                    <Text
                      cursor="pointer"
                      _hover={{ color: "teal.500" }}
                      onClick={() => navigate("/configuracoes/parametros")}
                    >
                      Parâmetros
                    </Text>
                  )}
                  {can('configuracoes', 'pontoEletronico') && (
                    <ComingSoonItem>Ponto Eletrônico</ComingSoonItem>
                  )}
                </VStack>
              </AccordionPanel>
            </AccordionItem>
          )}
        </VStack>
      </Accordion>
      {user && (
        <Box mt="5" px={isOpen ? "5" : "0"} display="flex" flexDirection="column" alignItems={isOpen ? "flex-start" : "center"}>
          <Flex
            align="center"
            gap={2}
            px={isOpen ? 0 : 0}
            py={2}
            mb={2}
            borderRadius="md"
            cursor="pointer"
            _hover={{ bg: 'teal.50' }}
            onClick={() => navigate('/perfil')}
            w="100%"
            justifyContent={isOpen ? "flex-start" : "center"}
          >
            <Icon as={MdPerson} color="gray.500" />
            {isOpen && <Text fontSize="sm" color="gray.600">Meu Perfil</Text>}
          </Flex>
          {isOpen ? (
            <Button
              colorScheme="teal"
              variant="outline"
              onClick={() => {
                if (telemedicinaAberta) {
                  toast({
                    title: "Teleatendimento em andamento",
                    description:
                      "Finalize a chamada na janela de telemedicina antes de sair.",
                    status: "warning",
                    duration: 5000,
                    isClosable: true,
                  });
                  return;
                }
                logout();
              }}
            >
              Logoff
            </Button>
          ) : (
            <Button
              colorScheme="teal"
              variant="outline"
              size="sm"
              onClick={() => {
                if (telemedicinaAberta) {
                  toast({
                    title: "Teleatendimento em andamento",
                    description:
                      "Finalize a chamada na janela de telemedicina antes de sair.",
                    status: "warning",
                    duration: 5000,
                    isClosable: true,
                  });
                  return;
                }
                logout();
              }}
              px={2}
            >
              ↩
            </Button>
          )}
          {isOpen && <Text mt={4}>{packageInfo.version} v</Text>}
        </Box>
      )}
    </Box>
    </>
  );
};

export default Sidebar;
